import CompanyTeamListView from "@/views/company/team/CompanyTeamListView";

export default [
  {
    name: "pages.company.team",
    path: "team",
    component: CompanyTeamListView
  },
  
  
];
